import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AnswerType,
  applyEvent,
  CommonOrCommonRetirementFlug,
  Demander,
  InquiryCode,
  MultiplyingFactor,
  Prefectures,
  Status,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import { GlobalContext } from "../../context/globalContext";
import {
  IAPI_APP009_Response,
  IAPI_APP016_Request,
  IAPI_APP011_Request,
} from "../../type/apiType";
import { TkGetCode } from "../../utils/TkGetCode";
import "./_style.scss";
import { httpAPI_APP009, httpAPI_APP016, httpAPI_APP011 } from "./api/request";
import { MaePeriod } from "./components/components";
import {
  schema,
  tableListAnswer,
  tableListContractor,
  tableListLawyer,
  tableListStaff,
  canNotTableListAnswer,
  headList,
} from "./parts";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import { ITkViewButtonJudgementStatus } from "../../type/componentsType/TkViewButtonJudgement";
import TkMemo from "../../components/molecules/TkMemo";
import { BusinessContext } from "../../context/businessContext";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import {
  isStatusAfterApproval,
  toNumberOrUndefined,
} from "../../utils/useTools";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import _ from "lodash";

/**
 * SCRW060102 退職手当金支給予定額の証明依頼書
 * @return SCRW060102
 */
const SCRW060102 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [stateTableList, setStateTableList] = useState<any>([]);
  const [res, setRes] = useState<IAPI_APP009_Response>({});
  const [open, setOpen] = useState<boolean>(false);
  const [statusCd, setStatusCd] = useState<any>();
  const [demanderKbn, setDemanderKbn] = useState<string>();
  const [paymentMultiplier1, setPaymentMultiplier1] = useState<string>();
  const [paymentMultiplier2, setPaymentMultiplier2] = useState<string>();
  const [answerFlg, setAnswerPossibilityFlg] = useState<string>();
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [bodyList, setBodyList] = useState<any>([]);
  const [status, setStatus] = useState<ITkViewButtonJudgementStatus>();
  const [corpApplyKbn, setCorpApplyKbn] = useState<"1" | "other" | undefined>(
    "1"
  );
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const applyId = location.state?.applyId ?? 0;
  const [maePeriod1, setMaePeriod1] = useState<any>({});
  const [maePeriod2, setMaePeriod2] = useState<any>({});
  const ref = useRef<{ submit: any } | null>(null);

  useEffect(() => {
    handleCallApiInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCallApiInit = async () => {
    // 退職手当金支給決定額の証明依頼 参照API呼び出し
    try {
      const res = await httpAPI_APP009({
        applyId,
      });

      if (res.resultCd === "I0000") {
        const { latestApplyStatus, corpApplyKbn } = res;
        if (!isKiko || res.formList?.length === 0) {
          setState({
            ...state,
            errorMsgId: "TKMSG_SCR0044E",
          });
        }
        setStatusCd(res.latestApplyStatus);
        setStatus(latestApplyStatus as ITkViewButtonJudgementStatus);
        setCorpApplyKbn(corpApplyKbn as any);
        setFakeTable(res);
        setRes(res);
        const bodyList = [
          [{ children: res.symbolNo }, { children: res.decisionDate }],
        ];
        setBodyList(bodyList);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const setFakeTable = (
    res: IAPI_APP009_Response,
    decisionDemanderKbn?: string,
    answerPossibilityFlg?: string
  ) => {
    setState({
      ...state,
      errorMsgId: "",
    });
    //上
    if (decisionDemanderKbn !== undefined) {
      res.decisionDemanderKbn = decisionDemanderKbn;
    }
    if (answerPossibilityFlg !== undefined) {
      res.answerPossibilityFlg = answerPossibilityFlg;
    }
    let kbn = res.decisionDemanderKbn;

    let table: any[] = [];
    switch (kbn) {
      case Demander["共済契約者"]:
        table = _.cloneDeep(tableListContractor);
        break;
      case Demander["法人職員"]:
        table = _.cloneDeep(tableListStaff);
        break;
      case Demander["弁護士"]:
        table = _.cloneDeep(tableListLawyer);
        break;
    }
    if (table.length === 0) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0044E",
      });
      return;
    }
    // 請求者選択
    setDemanderKbn(res.decisionDemanderKbn);

    const fileList = res.formList;
    const daityoFile = fileList?.find((item: any) => item.formClass === "2");
    const bengoshiFile = fileList?.find((item: any) => item.formClass === "35");
    const identificationFile = fileList?.find(
      (item: any) => item.formClass === "36"
    );

    let downloadLink1 = table.find((item) => item.keyword === "downloadLink1")!;
    if (downloadLink1) {
      downloadLink1.dataname = daityoFile?.fileName;
      downloadLink1.base64filedata = daityoFile?.fileBase64;
      downloadLink1.downloadBase64 = true;
    }

    let downloadLink2 = table.find((item) => item.keyword === "downloadLink2")!;
    if (downloadLink2) {
      if (fileList?.find((item: any) => item.formClass === "35")) {
        downloadLink2.dataname = bengoshiFile?.fileName;
        downloadLink2.base64filedata = bengoshiFile?.fileBase64;
        downloadLink2.downloadBase64 = true;
      } else if (fileList?.find((item: any) => item.formClass === "36")) {
        downloadLink2.dataname = identificationFile?.fileName;
        downloadLink2.base64filedata = identificationFile?.fileBase64;
        downloadLink2.downloadBase64 = true;
      }
    }

    // 職員住所（法人職員）
    let prefectureCd = table.find((item) => item.keyword === "prefectureCd")!;
    let deliveryPrefecture = table.find(
      (item) => item.keyword === "deliveryPrefecture"
    )!;
    if (deliveryPrefecture) {
      deliveryPrefecture.valueObject = {
        prefectures: TkGetCode(Prefectures, res.deliveryPrefecture),
        city: res.deliveryAddressCity,
        address: res.deliveryAddressOthers,
      };
    }
    if (prefectureCd) {
      prefectureCd.valueObject = {
        prefectures: TkGetCode(Prefectures, res.prefectureCd),
        city: res.addressCity,
        address: res.addressOthers,
      };
    }

    const answer = res.answerPossibilityFlg || answerFlg;

    //下
    const nowStatus = [Status["受理待ち"], Status["再受理待ち"]].includes(
      res.latestApplyStatus as Status
    );

    let tableListAnswerArr =
      answer === "1" ? tableListAnswer : canNotTableListAnswer;

    tableListAnswerArr.forEach((item: any) => {
      item.showLine = true;
    });

    let answerPossibility = tableListAnswerArr.find(
      (item) => item.keyword === "answerPossibilityFlg"
    );
    let paymentMultiplierKbn2 = tableListAnswerArr.find(
      (item) => item.keyword === "paymentMultiplierKbn2"
    );
    let retirementAllowanceExpectAmt2 = tableListAnswerArr.find(
      (item) => item.keyword === "retirementAllowanceExpectAmt2"
    );
    let paymentMultiplierKbn1 = tableListAnswerArr.find(
      (item) => item.keyword === "paymentMultiplierKbn1"
    );
    let maePeriod1 = tableListAnswerArr.find(
      (item) => item.keyword === "maePeriod1"
    );
    let maePeriod2 = tableListAnswerArr.find(
      (item) => item.keyword === "maePeriod2"
    );
    let noAnswerReason = tableListAnswerArr.find(
      (item) => item.keyword === "noAnswerReason"
    );

    // 回答種類選択
    setAnswerPossibilityFlg(res.answerPossibilityFlg);
    if (answerPossibility) {
      answerPossibility.onGetValue = (event: any) => {
        setAnswerPossibilityFlg(event);
      };
    }

    // 支給乗率①
    if (paymentMultiplierKbn1) {
      paymentMultiplierKbn1.onGetValue = (event: any) => {
        res.paymentMultiplierKbn1 = event;
        setPaymentMultiplier1(event);
      };
    }

    // 支給乗率②
    if (paymentMultiplierKbn2) {
      paymentMultiplierKbn2.onGetValue = (event: any) => {
        res.paymentMultiplierKbn2 = event;
        setPaymentMultiplier2(event);
      };
    }

    //制度改正加入年月日
    let firstJoinDate1 = tableListAnswerArr.find(
      (item) => item.keyword === "firstJoinDate1"
    )!;

    let firstJoinDate2 = tableListAnswerArr.find(
      (item) => item.keyword === "firstJoinDate2"
    )!;
    firstJoinDate1 && (firstJoinDate1.setDefaultValue = res.firstJoinDate);
    firstJoinDate2 && (firstJoinDate2.setDefaultValue = res.firstJoinDate);
    //仮退職年月日
    let tentativeRetireDate1 = tableListAnswerArr.find(
      (item) => item.keyword === "tentativeRetireDate1"
    )!;

    let tentativeRetireDate2 = tableListAnswerArr.find(
      (item) => item.keyword === "tentativeRetireDate2"
    )!;
    tentativeRetireDate1 &&
      (tentativeRetireDate1.setDefaultValue = res.retirePlanDay1);
    tentativeRetireDate2 &&
      (tentativeRetireDate2.setDefaultValue = res.retirePlanDay2);
    //被共済職員期間①
    maePeriod1 &&
      (maePeriod1.node = (
        <MaePeriod
          year={res.maePeriodYear1}
          month={res.maePeriodMonth1}
          disabled={!nowStatus}
          onChange={(value: any) => setMaePeriod1(value)}
        />
      ));
    maePeriod2 &&
      (maePeriod2.node = (
        <MaePeriod
          year={res.maePeriodYear2}
          month={res.maePeriodMonth2}
          disabled={!nowStatus}
          onChange={(value: any) => setMaePeriod2(value)}
        />
      ));

    //支給乗率①が"1"(普通退職の乗率を適用)の場合
    if (res.paymentMultiplierKbn1 && res.answerPossibilityFlg === "1") {
      tableListAnswerArr.find(
        (item) => item.keyword === "retirementAllowanceExpectAmt1"
      )!.setDefaultValue =
        res.paymentMultiplierKbn1 === MultiplyingFactor["普通退職の乗率を適用"]
          ? res.retirementAllowanceExpectAmtGeneral1
          : res.retirementAllowanceExpectAmtHc1;
    }
    //支給乗率②が"1"(普通退職の乗率を適用)の場合
    if (
      res.paymentMultiplierKbn2 &&
      res.answerPossibilityFlg === "1" &&
      retirementAllowanceExpectAmt2
    ) {
      retirementAllowanceExpectAmt2.setDefaultValue =
        res.paymentMultiplierKbn2 === MultiplyingFactor["普通退職の乗率を適用"]
          ? res.retirementAllowanceExpectAmtGeneral2
          : res.retirementAllowanceExpectAmtHc2;
    }
    // 被共済職員氏名
    tableListAnswerArr.find(
      (item) => item.keyword === "answerStaffName"
    )!.setDefaultValue = res.staffName;
    // 生年月日
    tableListAnswerArr.find(
      (item) => item.keyword === "answerBirthday"
    )!.setDefaultValue = res.staffBirthday;
    // 勤務先
    tableListAnswerArr.find(
      (item) => item.keyword === "workPlace"
    )!.setDefaultValue = res.facilityName;

    table = [...table, ...tableListAnswerArr];
    // 初期表示
    let i: keyof typeof res;
    for (i in res) {
      let j = i;
      const targetObj = table.find(
        (item: any) =>
          item.keyword === j &&
          item.type !== "lineTitle" &&
          item.type !== "node" &&
          item.type !== "nodeInLine"
      );
      if (res[j] !== null && targetObj !== undefined) {
        targetObj.setDefaultValue = res[j];
      }
    }

    // 退職（予定）年月日②が設定されていない場合
    if (!res.retirePlanDay2) {
      retirementAllowanceExpectAmt2 &&
        (retirementAllowanceExpectAmt2.showLine = false);
      paymentMultiplierKbn2 && (paymentMultiplierKbn2.showLine = false);
      maePeriod2 && (maePeriod2.showLine = false);
    }

    // 最新申請状態が"受理待ち"または"再受理待ち"時、下記項目活性
    paymentMultiplierKbn1 && (paymentMultiplierKbn1.disabled = !nowStatus);
    paymentMultiplierKbn2 && (paymentMultiplierKbn2.disabled = !nowStatus);
    answerPossibility && (answerPossibility.disabled = !nowStatus);
    noAnswerReason && (noAnswerReason.disabled = !nowStatus);

    setStateTableList([...table]);
  };

  useEffect(() => {
    res && setFakeTable(res, demanderKbn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [demanderKbn]);
  useEffect(() => {
    res && setFakeTable(res);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMultiplier1]);

  useEffect(() => {
    res && setFakeTable(res);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMultiplier2]);
  useEffect(() => {
    res && answerFlg && setFakeTable(res, demanderKbn, answerFlg);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [answerFlg]);

  const btnEvent = async (btnName: keyof typeof applyEvent) => {
    if (maePeriod1?.error || maePeriod2?.error) {
      return;
    }
    let reqObj: IAPI_APP016_Request = {
      applyId: res?.applyId,
      contractorNo: res?.contractorNo,
      screenId: "SCRW060102",
      reason: memoData,
    };
    if (memoCheck) {
      reqObj.inquiryCode = "3";
    }
    const event = applyEvent[btnName];

    switch (event) {
      case applyEvent["契約者に差戻し"]:
      case applyEvent["担当者に差戻し"]:
      case applyEvent["課長代理確認"]:
      case applyEvent["上長承認"]:
      case applyEvent["郵送"]:
        handleApplyStatusUpdate(event);
        break;
      case applyEvent["受理"]:
        ref.current?.submit();
        break;
      case applyEvent["承認"]:
        setOpen(true);
        break;
      case applyEvent["通知"]:
        let stateTemp: any = {
          applyId: res?.applyId,
          contractorNo: res?.contractorNo,
          screenId: "SCRW060102",
          reason: memoData,
        };
        if (memoCheck) {
          stateTemp.inquiryCode = 3;
        }
        setBusinessState({
          ...businessState,
          job_47: {
            ...businessState,
            ...stateTemp,
          },
        });

        navigate("/SCRW130001", {
          state: {
            applyId: res?.applyId,
            contractorNo: res?.contractorNo,
            screenId: "SCRW060102",
            reason: memoData,
            inquiryCode: memoCheck ? 3 : undefined,
          },
        });
        break;
    }
  };

  const onChange = (event: any) => {
    switch (event.target.type) {
      case "input":
        setMemoData(event.target.value);
        break;
      case "checkbox":
        setMemoCheck(event.target.value);
        break;
    }
  };

  const handleAccept = async (data: any) => {
    let reqObj: IAPI_APP011_Request = {
      applyId: res.applyId,
      answerKind: data.answerPossibilityFlg,
      staffName: res.staffName,
      birthday: res.staffBirthday,
      workPlace: res.facilityName,
      ...(data.answerPossibilityFlg === AnswerType["回答可能"]
        ? {
            retirementAllowanceExpectAmt1:
              res.retirementAllowanceExpectAmtGeneral1,
            joinDate: res.firstJoinDate,
            tentativeRetireDate1: res.retirePlanDay1,
            maePeriodYear1: toNumberOrUndefined(maePeriod1?.year),
            maePeriodMonth1: toNumberOrUndefined(maePeriod1?.month),
            paymentMultiplierKbn1: data.paymentMultiplierKbn1,
            ...(!!res.retirePlanDay2 && {
              retirementAllowanceExpectAmt2:
                res.retirementAllowanceExpectAmtGeneral2,
              tentativeRetireDate2: res.retirePlanDay2,
              maePeriodYear2: toNumberOrUndefined(maePeriod2?.year),
              maePeriodMonth2: toNumberOrUndefined(maePeriod2?.month),
              paymentMultiplierKbn2: data.paymentMultiplierKbn2,
            }),
          }
        : {
            noAnswerReason: data.noAnswerReason,
          }),
      applyEvent: applyEvent["受理"],
      inquiryCode: memoCheck ? InquiryCode["職員"] : undefined,
      reason: memoData,
    };

    try {
      // 退職手当金支給決定額の証明依頼　回答更新API 呼び出し
      const res = await httpAPI_APP011(reqObj);

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleApplyStatusUpdate = async (
    applyEvent: string,
    formData?: any
  ) => {
    let reqObj: IAPI_APP016_Request = {
      applyId: res.applyId,
      applyEvent,
      contractorNo: res.contractorNo,
      screenId: "SCRW060102",
      reason: memoData,
      ...(memoCheck && { inquiryCode: InquiryCode["職員"] }),
      ...(!!formData && {
        decisionDate: formData.settlementDate,
        symbolNo:
          TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
          "第" +
          (formData.symbolNumber ?? "") +
          "号",
      }),
    };

    try {
      // 申請状況更新API 呼び出し
      const res = await httpAPI_APP016(reqObj);

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRW060102" data-testid="SCRW060102">
      <TkKikoStepper
        applicationFlowType={"TYPE2"}
        businessType={"JOB-47"}
        corporateApplicationClassification={corpApplyKbn}
        applicationStatus={status}
      />
      <TkFakeTable
        ref={ref}
        list={stateTableList}
        ruleSchema={schema}
        showButton={false}
        onCheckAndSubmit={handleAccept}
      />
      <TkMemo
        showTable={true}
        bodyList={res?.statusList?.map((item) => {
          return [
            { children: item.managerName },
            { children: item.process },
            { children: item.createDate },
            { children: item.processComment },
          ];
        })}
        onChange={onChange}
      ></TkMemo>

      {isStatusAfterApproval(res?.latestApplyStatus) && (
        <TkTableWithNoLine headList={headList} bodyList={bodyList} />
      )}

      <Box className="btn">
        <TkBackButton />
        <TkViewButtonJudgement
          flowType={"TYPE2"}
          Status={statusCd}
          onClick={btnEvent}
          data-testid="TkViewButtonJudgement"
        />
      </Box>

      <TkApprovalDateSymbolNumberRegistrationDialog
        data-testid="SCRW040001PageForDialog"
        open={open}
        onClose={() => setOpen(false)}
        onSuccess={(e: any) => handleApplyStatusUpdate(applyEvent["承認"], e)}
      />
    </Box>
  );
};

export default SCRW060102;
